(() => {
  if (window.responsiveVideoComponent) return

  const selectors = {
    videoElem: '[data-hook="video"]',
    videoDesktopElem: '[data-hook="video-desktop"]',
  }

  window.responsiveVideoComponent = function responsiveVideo({ wrapper }) {
    if (!wrapper) return

    const cache = {
      videoElem: wrapper.querySelector(selectors.videoElem),
      videoDesktopElem: wrapper.querySelector(selectors.videoDesktopElem),
    }

    function init() {
      if (cache.videoElem || cache.videoDesktopElem) {
        observeVideos()
      }
    }

    // Registers mobile & desktop videos to lazy video observer
    // A video becomes visible either by scrolling to the section or
    // by becoming visible through css (e.g. video w/'max-md:tw-hidden' renders after it reaches the 'md' breakpoint)
    function observeVideos() {
      const lazyVideoObserver = new IntersectionObserver((entries) => {
        entries.forEach((videoOrIframe) => {
          if (videoOrIframe.isIntersecting) {
            const { target } = videoOrIframe
            const isVideo = target.tagName === 'VIDEO'
            const isIframe = target.tagName === 'IFRAME'

            if (!isVideo && !isIframe) return

            if (isVideo) {
              Array.from(target.children).forEach((videoSource) => {
                if (videoSource.tagName === 'SOURCE' && videoSource.dataset.src) {
                  videoSource.src = videoSource.dataset.src
                }
              })

              target.load()
            }

            if (isIframe && target.dataset.src) {
              target.src = target.dataset.src
            }

            target.setAttribute('data-video-loaded', true)
            lazyVideoObserver.unobserve(target)
          }
        })
      })

      ;[cache.videoElem, cache.videoDesktopElem].filter(Boolean).forEach((lazyVideo) => {
        lazyVideoObserver.observe(lazyVideo)
      })
    }

    init()
  }
})()
